import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import googleAnalytics from '../../../services/googleAnalytics';
import styles from './CookieConsent.module.css';

const CookieConsent = () => {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);
  const [showDeclineNotification, setShowDeclineNotification] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setIsVisible(true);
    }
  }, []);
  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
    
    // Initialiser Google Analytics après acceptation
    googleAnalytics.initialize();
    
    // Tracker l'événement de consentement
    setTimeout(() => {
      googleAnalytics.trackEvent('cookie_consent', {
        event_category: 'privacy',
        event_action: 'accept',
        event_label: 'cookie_banner'
      });
    }, 1000);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
    
    // Désactiver et nettoyer les analytics
    googleAnalytics.disable();
    
    // Afficher une notification user-friendly au lieu d'une alert
    setShowDeclineNotification(true);
    
    // Masquer la notification après 5 secondes
    setTimeout(() => {
      setShowDeclineNotification(false);
    }, 5000);
  };

  return (
    <>
      {isVisible && (
        <div className={styles.cookieConsent}>
          <div className={styles.cookieConsentContent}>
            <p>{t('cookies.message')}</p>
            <p className={styles.cookieConsentDescription}>
              {t('cookies.description')}
            </p>
            <div className={styles.cookieConsentButtons}>
              <button
                onClick={handleAccept}
                className={`${styles.cookieConsentButton} ${styles.cookieConsentButtonAccept}`}
              >
                {t('cookies.accept')}
              </button>
              <button
                onClick={handleDecline} 
                className={`${styles.cookieConsentButton} ${styles.cookieConsentButtonDecline}`}
              >
                {t('cookies.decline')}
              </button>
            </div>
          </div>
        </div>
      )}
      
      {showDeclineNotification && (
        <div className={styles.declineNotification}>
          <div className={styles.notificationContent}>
            <div className={styles.notificationHeader}>
              <span className={styles.notificationIcon}>ℹ️</span>
              <h4>{t('cookies.declined_title')}</h4>
              <button 
                className={styles.notificationClose}
                onClick={() => setShowDeclineNotification(false)}
                aria-label="Fermer"
              >
                ×
              </button>
            </div>
            <p className={styles.notificationMessage}>
              {t('cookies.declined_message')}
            </p>
            <p className={styles.notificationSubMessage}>
              {t('cookies.declined_submessage')}
            </p>
          </div>
        </div>
      )}
    </>
  );
};

export default CookieConsent;
